// const new_service_basis = window.gtaAiConfig.service_basis
 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis


export default {
  /**
   * 查询行业直播列表
   */
  getTradeVideoList: `${new_service_basis}/ai/training/industryVideo/getTradeVideoList`,
  /**
   * 根据视频id查询详细信息
   */
  getTradeVideoByVideoId: `${new_service_basis}/ai/training/industryVideo/getTradeVideoByVideoId`
};
